import { combineReducers } from 'redux';
import activityHealth from './activityHealth';
import concepts from './concepts';
import conceptsFeedback from './conceptsFeedback';
import display from './display';
import fillInBlank from './fillInBlank';
import filters from './filtersReducer';
import generatedIncorrectSequences from './generatedIncorrectSequences';
import lessons from './lessons';
import massEdit from './massEdit';
import playLesson from './questionReducer';
import questions from './questions';
import responses from './responsesReducer';
import sessions from './sessions';
import titleCards from './titleCards';
import playTurk from './turk';

const combinedReducers = combineReducers({
  activityHealth,
  concepts,
  conceptsFeedback,
  display,
  fillInBlank,
  filters,
  generatedIncorrectSequences,
  lessons,
  massEdit,
  playLesson,
  questions,
  responses,
  sessions,
  titleCards,
  playTurk
});

export default combinedReducers;
